<div class="card">
  <div class="sub-component-placeholder">
    <div class="col-5">
      <app-input-date-time [name]="'money-transfer-start-date' | translate" [date]="moneyTransfer.startDate" (dateChange)="startDateChange($event)" [withImage]="true" [timeZone]="'secca'">
      </app-input-date-time>
    </div>
  </div>
</div>
